export default "__VITE_ASSET__d87068e6__"